/* tslint:disable */
/* eslint-disable */
/**
 * SISCC Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConfigEncoding {
    Default = 'Default',
    External = 'External'
}

export function ConfigEncodingFromJSON(json: any): ConfigEncoding {
    return ConfigEncodingFromJSONTyped(json, false);
}

export function ConfigEncodingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigEncoding {
    return json as ConfigEncoding;
}

export function ConfigEncodingToJSON(value?: ConfigEncoding | null): any {
    return value as any;
}

